import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';

// config
import fetch from '../../../../config/service';
import apiCalls from '../../../../config/apiCalls';
import config from '../../../../config/config';
import { useNavigate } from 'react-router-dom';

import { useForm, Controller } from 'react-hook-form';
import { Button } from 'primereact/button';
import DoInputField from '../../../Form/Fields/DoInputField';
import DoDateField from '../../../Form/Fields/DoDateField';
import DoPasswordField from '../../../Form/Fields/DoPasswordField';
import DoTextareaField from '../../../Form/Fields/DoTextareaField';
import DoFileUplaod from '../../../Form/Fields/DoFileUpload';
import showToasterMessage from '../../../UI/ToasterMessage/toasterMessage';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import DoSelectField from '../../../Form/Fields/DoSelectField';
import '../../../../scss/containers/profile.scss';


const Profile = (props) => {


  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .required('First Name is required')
      .min(2, 'First Name must be at least 2 characters'),
    email: Yup.string()
      .email('Enter a valid email address')
      .required('Email is required'),
    address: Yup.string()
      .nullable()
      .max(250, 'Address cannot exceed 250 characters'),
    phone: Yup.string()
      .matches(/^[0-9]{10}$/, 'Enter a valid 10-digit phone number')
      .nullable(),
  });

  const modelTypes = [
    { label: "Open AI", value: "openai", color: "success" },
    { label: "Ollama",  value: "ollama",  color: "primary" },
    { label: "Gemini",  value: "gemini",  color: "warning" },
  ];
  const profileFields = [
    {
      name: 'firstName',
      type: 'text',
      placeholder: 'First Name',
      label: 'First Name',
      width: 110,
      id: 'firstName',
      displayinaddForm: 'true',
      displayineditForm: 'true',
      displayinlist: 'true',
      controllerName: null,
      fieldType: 'Link',
      displayinregisterForm: true,
      disabled: true,
      globalSearchField: 'true',
      isBulkUploadField: true,
      show: true,
      addFormOrder: 1,
      editFormOrder: 1,
      isFieldRequired: 'false',
      mobile: true,
      displayInSettings: true
    },
    {
      name: 'lastName',
      type: 'text',
      placeholder: 'Last Name',
      label: 'Last Name',
      width: 110,
      id: 'lastName',
      displayinaddForm: 'true',
      displayineditForm: 'true',
      displayinlist: 'true',
      controllerName: null,
      fieldType: 'Link',
      displayinregisterForm: true,
      disabled: true,
      globalSearchField: 'true',
      isBulkUploadField: true,
      show: true,
      addFormOrder: 2,
      editFormOrder: 2,
      isFieldRequired: 'false',
      mobile: true,
      displayInSettings: true
    },
    {
      name: 'email',
      type: 'email',
      placeholder: 'Email',
      label: 'Email',
      id: 'email',
      width: 150,
      displayinaddForm: 'true',
      displayineditForm: 'false',
      displayinlist: 'true',
      controllerName: null,
      displayinregisterForm: true,
      isBulkUploadField: true,
      disabled: true,
      show: true,
      globalSearchField: 'true',
      required: true,
      isFieldRequired: 'true',
      addFormOrder: 2,
      editFormOrder: 2,
      mobile: true,
      displayInSettings: true
    },
    {
      name: 'address',
      type: 'textarea',
      placeholder: 'Address',
      label: 'Address',
      id: 'address',
      width: 180,
      displayinaddForm: 'true',
      displayineditForm: 'true',
      displayinlist: 'true',
      controllerName: null,
      show: true,
      disabled: false,
      globalSearchField: 'true',
      isBulkUploadField: true,
      addFormOrder: 3,
      editFormOrder: 3,
      isFieldRequired: 'false',
      mobile: true,
      displayInSettings: true
    },
    {
      name: 'phone',
      type: 'text',
      placeholder: 'Phone',
      label: 'Phone',
      id: 'phone',
      width: 110,
      displayinaddForm: 'true',
      displayineditForm: 'true',
      displayinlist: 'true',
      controllerName: null,
      displayinregisterForm: true,
      isBulkUploadField: true,
      show: true,
      disabled: false,
      addFormOrder: 5,
      editFormOrder: 5,
      globalSearchField: 'false',
      isFieldRequired: 'false',
      mobile: true,
      displayInSettings: true,
      fieldType: 'Link',
      style: {
        color: '#0e4768',
        cursor: 'pointer',
        textTransform: 'capitalize'
      }
    },
    {
      name: "aiType",
      type: "dropDown",
      placeholder: "AI Model",
      label: "AI Model",
      header: "AI Model",
      field: "model",
      options: modelTypes,
      width: "120px",
      textAlign: "center",
      show: true,
      displayinaddForm: "true",
      displayineditForm: "true",
      displayinlist: "true",
      globalSearchField: "true",
      required: true,
      displayInSettings: true,
      fieldType: "dropDown",
      tDisplay: true,
      sortable: true,
      filter: true,
      style: {
        textTransform: 'uppercase',
        height: ""
      }
    },
  ]

  const navigate = useNavigate();
  const [userData, setUserData] = useState({});
  const [avatarUrl, setAvatarUrl] = useState(null); // single source of truth[web:22]

  const {
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
    control,
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: 'onBlur',
  });

  useEffect(() => {
    getUserData();
  }, []);

  // when userData.photo changes, compute avatarUrl
  useEffect(() => {
    if (userData?.photo) {
      const url = userData.photo.startsWith('http')
        ? userData.photo
        : `${config.profileUrl}/${userData.photo}`;
      setAvatarUrl(url);
    } else {
      setAvatarUrl(null);
    }
  }, [userData]);

  const getUserData = async () => {
    if (!localStorage.getItem('loginCredentials')) return;
    let user = JSON.parse(localStorage.getItem('loginCredentials'));
    let Url = `${apiCalls.employees}/${user._id}`;
    return fetch('GET', Url)
      .then(async (response) => {
        if (response && response.details) {
          setUserData({ ...response.details });
          user = Object.assign(user, response.details);
          await localStorage.setItem(
            'loginCredentials',
            JSON.stringify(user)
          );
          reset(response.details);
        }
      })
      .catch((err) => err);
  };

  const updateProfile = (formData) => {
    if (!formData) return;
    delete formData.email;
    delete formData.password;
    let Url;
    if (localStorage.getItem('loginCredentials')) {
      let user = JSON.parse(localStorage.getItem('loginCredentials'));
      Url = `${apiCalls.employees}/${user._id}`;
    }
    return fetch('PUT', Url, formData)
      .then(async (response) => {
        if (response && response.respCode && response.respCode === 205) {
          showToasterMessage(response.respMessage, 'success');
          getUserData();
          navigate(-1);
        } else if (response && response.errorMessage) {
          showToasterMessage(response.errorMessage, 'error');
        }
      })
      .catch((err) => err);
  };

  const onClickUpdate = (data) => {
    updateProfile({ ...data });
  };

  const handleBack = () => {
    navigate(-1);
  };

  const resetData = () => {
    profileFields.forEach((item) => {
      const currentValue = userData[item.name];
      setValue(item.name, currentValue || '');
    });
  };

  const getInitials = () => {
    const firstName = userData.firstName || '';
    const lastName = userData.lastName || '';
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  };

  // delete photo: works for both cases (existing DB image or newly uploaded)[web:28]
  const handleDeletePhoto = async () => {
    let Url;
    if (localStorage.getItem('loginCredentials')) {
      const user = JSON.parse(localStorage.getItem('loginCredentials'));
      Url = `${apiCalls.employees}/${user._id}`;
    }

    await fetch('PUT', Url, { photo: null });
    setUserData((prev) => ({ ...prev, photo: null }));
    setAvatarUrl(null);
  };

  return (
    <Col md={12} lg={12} xl={12} className="mx-auto">
      <Card>
        <CardBody className="p-4 profile-main" style={{ height: "calc(100vh - 100px)", overflowY: "scroll" }}>
          <Row className="mb-4">
            <Col md={4} className="mb-4 mb-md-0">
              <div className="profile-avatar-section">
                {avatarUrl ? (
                  <div
                    style={{
                      position: 'relative',
                      display: 'inline-block',
                    }}
                  >
                    <img
                      src={avatarUrl}
                      alt={`${userData.firstName} ${userData.lastName}`}
                      className="profile-avatar-placeholder"
                      style={{ objectFit: 'cover' }}
                    />
                  </div>
                ) : (
                  <div className="profile-avatar-placeholder">
                    {getInitials()}
                  </div>
                )}

                <h5 className="mb-2">
                  {userData.firstName} {userData.lastName}
                </h5>
                <p className="text-muted mb-3">{userData.email}</p>

                <Controller
                  name={'photo'}
                  control={control}
                  render={({ field, fieldState }) => (
                    <Controller
                      name={'photo'}
                      control={control}
                      render={({ field, fieldState }) => (
                        <DoFileUplaod
                          field={field}
                          url={"uploads?uploadWhileCreate=true&uploadPath=employees"}
                          type={'profile'}
                          acceptType="image/*"
                          showPreview={false}
                          userClickUpload={true}
                          maxFileSize={5000000}
                          isMultiple={false}
                          modeType={'basic'}
                          autoSubmit={true}
                          profile={true}
                          setAvatarUrl={setAvatarUrl}
                        />)}
                    />
                  )}
                />
                <p className="upload-hint">
                  Max file size: 5MB • Supports: JPG, PNG
                </p>
              </div>
            </Col>

            <Col md={8}>
              <h3 className="profile-section-title">Personal Information</h3>
              <form onSubmit={handleSubmit(onClickUpdate)}>
                <Row>
                  {profileFields.map((item, index) => (
                    <Col
                      sm={12}
                      md={item.type === 'textarea' ? 12 : 6}
                      key={index}
                      className="profile-form-group"
                    >
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <label className="profile-form-label">
                          {item.label}
                          {item.required && (
                            <span className="field-required"></span>
                          )}
                        </label>
                        {errors[item.name] && (
                          <span className="error-message">
                            {errors[item.name]?.message}
                          </span>
                        )}
                      </div>

                      {(item.type === 'text' || item.type === 'email') && (
                        <Controller
                          name={item.name}
                          control={control}
                          render={({ field, fieldState }) => (
                            <DoInputField
                              input={field}
                              id={field.id}
                              name={field.name}
                              field={field}
                              type={item.type}
                              fieldState={fieldState}
                              errors={errors}
                              disable={item.disabled}
                              placeholder={item.placeholder}
                              className="profile-form-control"
                            />
                          )}
                        />
                      )}

                      {item.type === 'textarea' && (
                        <Controller
                          name={item.name}
                          control={control}
                          render={({ field, fieldState }) => (
                            <DoTextareaField
                              input={field}
                              id={field.id}
                              name={field.name}
                              field={field}
                              fieldState={fieldState}
                              errors={errors}
                              placeholder={item.placeholder}
                              rows={item.rows || 3}
                              className="profile-form-control"
                            />
                          )}
                        />
                      )}

                      {item.type === 'dropDown' && (
                        <Controller
                          name={item.name}
                          control={control}
                          render={({ field, fieldState }) => (
                            <DoSelectField
                              input={field}
                              id={field.id}
                              name={field.name}
                              field={field}
                              fieldState={fieldState}
                              errors={errors}
                              options={item.options}
                              optionLabel={
                                item.optionLabel
                                  ? item.optionLabel
                                  : 'label'
                              }
                              placeholder={item.placeholder}
                              item={item}
                            />
                          )}
                        />
                      )}
                    </Col>
                  ))}
                </Row>

                <div className="profile-footer mt-4">
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                    <div className="mb-3 mb-md-0">
                      <span className="text-muted">
                        Last updated:{' '}
                        {new Date().toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric',
                        })}
                      </span>
                    </div>

                    <div className="d-flex flex-wrap justify-content-center justify-content-md-end gap-2">
                      <Button
                        type="button"
                        className="profile-btn-secondary"
                        onClick={handleBack}
                        icon="pi pi-arrow-left"
                        label="Back"
                      />
                      {/* <Button
                        type="button"
                        className="profile-btn-secondary"
                        onClick={resetData}
                        icon="pi pi-refresh"
                        label="Reset"
                      /> */}
                      <Button
                        type="submit"
                        icon="pi pi-check"
                        label="Update Profile"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Profile;
